import Requests from "@/services/Requests";

const state = {
  products: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allProducts: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  productById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of products based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter products by. Defaults to 0.
   * @return {Array} An array of products filtered by the given page number. If page is 0, returns all products.
   */
  getProducts:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.products.data
        : state.products.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllProducts: (state) => state.allProducts.data,
  getProductStatus: (state) => state.products.status,
  getProductCount: (state) => state.products.count,
  getProductPage: (state) => state.products.page,
  getProductPages: (state) => Math.ceil(state.products.count / 10),
  getProductsLoading: (state) => state.products.status === "loading",
  getProductById: (state) => (id) =>
    state.productById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the product in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the product.
   */
  SET_PRODUCT_STATUS(state, payload) {
    console.log(state.products, "status: ", payload);
    state.products.status = payload;
  },
  /**
   * Sets the products and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of products.
   * @param {number} payload.count - The total count of products.
   */
  SET_PRODUCTS(state, payload) {
    state.products.data = payload.items;
    state.products.count = payload.count;
  },
  /**
   * Sets the products and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of products.
   * @param {number} payload.count - The total count of products.
   */
  SET_ALL_PRODUCTS(state, payload) {
    console.log("SET_ALL_PRODUCTS", payload);
    state.allProducts.data = payload.items;
    state.allProducts.count = payload.count;
  },
  /**
   * Updates the status of the update product in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the product.
   */
  SET_UPDATE_PRODUCT_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an product object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated product object.
   * @return {void}
   */
  SET_UPDATE_PRODUCT(state, payload) {
    const index = state.products.data.findIndex((d) => d.id === payload.id);
    if (index !== -1) {
      const product = state.products.data[index];
      state.products.data[index] = { ...product, ...payload };
    }
  },
  SET_CREATE_PRODUCT_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new product to the list of products in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The product object to be added.
   * @return {void}
   */
  SET_CREATE_PRODUCT(state, payload) {
    state.products.data.push(payload);
  },
  /**
   * Updates the status of the delete product in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the product.
   */
  SET_DELETE_PRODUCT_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an product from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the product ID to be deleted.
   * @param {number} payload.id - The ID of the product to be deleted.
   * @return {void}
   */
  SET_DELETE_PRODUCT(state, payload) {
    state.products.data = state.products.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_PRODUCT_BY_ID_STATUS(state, payload) {
    state.productById.status = payload;
  },
  SET_PRODUCT_BY_ID(state, payload) {
    state.productById.data.push(payload);
  },
};

const actions = {
  async getProducts({ commit, state }, payload) {
    const status = state.products.status;
    commit("SET_PRODUCT_STATUS", "loading");
    console.log(payload, "payload");
    const response = await Requests.Product.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_PRODUCTS", {
        items: response.data.items.map((item) => ({
          ...item,
          page: payload.query.page,
        })),
        count: response.data.count,
      });
      if (status === "unitiliazed")
        commit("SET_ALL_PRODUCTS", {
          items: response.data.items.map((item) => ({
            ...item,
            page: payload.query.page,
          })),
          count: response.data.count,
        });
    }
    commit("SET_PRODUCT_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an product by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the product data.
   * @param {string} payload.fullName - The full name of the product.
   * @param {string} payload.phoneNumber - The phone number of the product.
   * @param {string} payload.email - The email of the product.
   * @param {string} payload.regionId - The ID of the region the product belongs to.
   * @param {File} payload.image - The image of the product.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createProduct({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.Product.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_PRODUCT", {
          id: response.data,
          fullName: payload.fullName,
          phoneNumber: payload.phoneNumber,
          email: payload.email,
          regionId: payload.regionId,
          image: payload.image,
          workStartTime: payload.workStartTime,
          workEndTime: payload.workEndTime,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an product by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the product data to update.
   * @param {string} payload.fullName - The full name of the product.
   * @param {string} payload.phoneNumber - The phone number of the product.
   * @param {string} payload.email - The email of the product.
   * @param {string} payload.regionId - The ID of the region the product belongs to.
   * @param {File} payload.image - The image of the product.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @param {boolean} payload.isActive - Whether the product is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateProduct({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.Product.Update(payload.data, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_PRODUCT", payload.data);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
      return response.message;
    } catch {
      console.log("buramı?");

      state.updateStatus = "error";
      return "FAIL";
    }
  },
  /**
   * Removes an product from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the product data.
   * @param {number} payload.id - The ID of the product to be removed.
   * @returns {Promise<void>} A promise that resolves when the product is successfully removed.
   */
  removeProduct({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.Product.Delete({ id })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
      })
      .catch(() => {
        state.deleteStatus = "error";
      });
  },
  /**
   * Retrieves an product by their ID and updates the product by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the product to retrieve.
   * @return {Promise} A promise that resolves when the product is successfully retrieved and the status is updated.
   */
  getProductById({ commit, state }, { id }) {
    // check if product already exists in the state;
    if (state.productById.data.find((product) => product.id === id))
      return state.productById.data.find((product) => product.id === id);
    commit("SET_PRODUCT_BY_ID_STATUS", "loading");
    return Requests.Product.GetById({ params: { id } })
      .then((response) => {
        commit("SET_PRODUCT_BY_ID", response.data);
        commit("SET_PRODUCT_BY_ID_STATUS", "success");
        return response.data;
      })
      .catch(() => {
        commit("SET_PRODUCT_BY_ID_STATUS", "error");
        return {};
      });
  },
};

export default { state, getters, mutations, actions };
